import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Typography } from '@material-ui/core';

import { ControlledSelect } from '@vyce/core/src/components/controlled-inputs/ControlledSelect';
import { OnboardingStepTitle } from '@vyce/core/src/components/OnboardingStepTitle';
import { TIME_INTERFACE_PERMISSIONS, TimeAndAttendanceLocation } from '@vyce/core/src/types';
import { usePermissions } from '@vyce/core/src/hooks/usePermissions';

import { ManualClockContext } from './ManualClockProvider';
import { useContext, useMemo } from 'react';

const rules = {
  required: 'Location is required',
};

const name = 'location';

const empty: TimeAndAttendanceLocation[] = [];

export const LocationStep = () => {
  const { action, shifts, locations, loading } = useContext(ManualClockContext);
  const { resourceIdsWith } = usePermissions();

  const { watch } = useFormContext();

  const value = watch(name);

  // Manual clocking is granted per location, so only offer the ones this person
  // holds it on. null means "all of them" — an owner or an internal admin.
  const allowedLocations = useMemo(() => {
    const allowedIds = resourceIdsWith(TIME_INTERFACE_PERMISSIONS.MANUALLY_CLOCK_WORKERS, 'location');
    if (allowedIds === null) return locations;
    return (locations || []).filter(location => !!location.uuid && allowedIds.includes(location.uuid));
  }, [locations, resourceIdsWith]);

  return (
    <>
      <OnboardingStepTitle
        text={`What location do you want to clock them ${action === 'in' ? 'into' : 'out of'}?`}
      />
      <ControlledSelect
        name={name}
        rules={rules}
        label="Select Location"
        margin="normal"
        items={allowedLocations || empty}
        multiple={false}
      />

      {value && shifts && !shifts.length && !loading && (
        <Typography color="error">There are no shifts assigned to this location.</Typography>
      )}
    </>
  );
};
